export default "__VITE_ASSET__CpG5Bien__"